@file:OptIn(InternalResourceApi::class)

package org.mifos.mobile.navigation.generated.resources

import kotlin.OptIn
import kotlin.String
import kotlin.collections.MutableMap
import org.jetbrains.compose.resources.InternalResourceApi
import org.jetbrains.compose.resources.LanguageQualifier
import org.jetbrains.compose.resources.ResourceItem
import org.jetbrains.compose.resources.StringResource

private const val MD: String = "composeResources/org.mifos.mobile.navigation.generated.resources/"

public val Res.string.app_name: StringResource by lazy {
      StringResource("string:app_name", "app_name", setOf(
        ResourceItem(setOf(LanguageQualifier("es"), ), "${MD}values-es/strings.commonMain.cvr", 10, 32),
        ResourceItem(setOf(), "${MD}values/strings.commonMain.cvr", 10, 32),
      ))
    }

public val Res.string.home: StringResource by lazy {
      StringResource("string:home", "home", setOf(
        ResourceItem(setOf(LanguageQualifier("es"), ), "${MD}values-es/strings.commonMain.cvr", 43, 20),
        ResourceItem(setOf(), "${MD}values/strings.commonMain.cvr", 43, 20),
      ))
    }

public val Res.string.not_connected: StringResource by lazy {
      StringResource("string:not_connected", "not_connected", setOf(
        ResourceItem(setOf(LanguageQualifier("es"), ), "${MD}values-es/strings.commonMain.cvr", 64, 73),
        ResourceItem(setOf(), "${MD}values/strings.commonMain.cvr", 64, 81),
      ))
    }

public val Res.string.profile: StringResource by lazy {
      StringResource("string:profile", "profile", setOf(
        ResourceItem(setOf(LanguageQualifier("es"), ), "${MD}values-es/strings.commonMain.cvr", 138, 23),
        ResourceItem(setOf(), "${MD}values/strings.commonMain.cvr", 146, 27),
      ))
    }

public val Res.string.transfer: StringResource by lazy {
      StringResource("string:transfer", "transfer", setOf(
        ResourceItem(setOf(LanguageQualifier("es"), ), "${MD}values-es/strings.commonMain.cvr", 162, 32),
        ResourceItem(setOf(), "${MD}values/strings.commonMain.cvr", 174, 28),
      ))
    }

@InternalResourceApi
internal fun _collectCommonMainString0Resources(map: MutableMap<String, StringResource>) {
  map.put("app_name", Res.string.app_name)
  map.put("home", Res.string.home)
  map.put("not_connected", Res.string.not_connected)
  map.put("profile", Res.string.profile)
  map.put("transfer", Res.string.transfer)
}
